
interface IQueryTouchTapRecognizerEvent {

}
interface IQueryTouchTapRecognizerConfig 
    extends IQueryTouchRecognizerConfig {
    // px per ms
    taps: number    
    // max press time in ms   
    time: number
    // max interval between multiple taps
    interval: number            
}
class QueryTouchTapRecognizer
    extends QueryTouchRecognizer<IQueryTouchTapRecognizerConfig> {

    constructor(config: IQueryTouchTapRecognizerConfig) {
        super(config);
    }

    isFulfilled(details: QueryTouchDetails, current: QueryTouchDetails) {
        return false;
    }
    async onStart(details: QueryTouchDetails) {
        throw new Error("Method not implemented.");
    }
    async onMove(start: QueryTouchDetails, current: QueryTouchDetails) {
        throw new Error("Method not implemented.");
    }
    async onStop(start: QueryTouchDetails, stop: QueryTouchDetails) {
        throw new Error("Method not implemented.");
    }
}